import { Component } from '@angular/core';
import { FormGroup, FormControl, FormArray } from '@angular/forms';
import { ModalBaseComponent, TranslatedToastrService, ValidationHandlerService } from 'lib/Vestra.shared';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { firstValueFrom } from 'rxjs/internal/firstValueFrom';
import { CoreService, Resource, ResourceModel, ResourceSaveModel } from 'src/app/services/api-services';
import { AbstractControl } from '@angular/forms';
import { HttpErrorResponse } from '@angular/common/http';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
    selector: 'app-resource-edit',
    templateUrl: './resource-edit.component.html',
    styleUrls: ['./resource-edit.component.scss'],
})
export class ResourceEditComponent extends ModalBaseComponent {
    constructor(private bsModalRef: BsModalRef, private coreService: CoreService, protected override validationHandlerService: ValidationHandlerService, protected override modalService: BsModalService, private translatedToastrService: TranslatedToastrService, protected override spinnerService: NgxSpinnerService) {
        super(spinnerService, modalService, validationHandlerService);
    }

    //input properties
    public title: string;
    public item: ResourceModel;

    //Languages
    public languageList: Resource[];

    //class properties

    private getFormGroup(): FormGroup {
        return new FormGroup({
            key: new FormControl({ value: '', disabled: true }),
            value: new FormControl({ value: '', disabled: true }),
            type: new FormControl({ value: '', disabled: true }),
            languageList: new FormArray([]),
        });
    }
    public form: FormGroup = this.getFormGroup();

    public getLanguageValueFormArray(): AbstractControl[] {
        return (this.form.get('languageList') as FormArray).controls;
    }

    public async init() {
        this.handleSpinner(
            firstValueFrom(this.coreService.createAndGetResourceListByKey(this.item.key))
                .then(res => {
                    this.languageList = res.result;

                    this.form = this.getFormGroup();
                    const formArray = this.form.get('languageList') as FormArray;

                    this.languageList.forEach(languageModel => {
                        const newFormGroup = new FormGroup({
                            languageId: new FormControl({ value: languageModel.id, disabled: false }),
                            languageCode: new FormControl({ value: languageModel.language, disabled: false }),
                            languageValue: new FormControl({ value: languageModel.value, disabled: false }),
                        });
                        formArray.push(newFormGroup);
                    });

                    this.form.patchValue(this.item);
                    return Promise.resolve(res);
                })
                .catch((err: HttpErrorResponse) => {
                    this.validationHandlerService.handleServerError(err, this.form);
                })
        );
    }

    public ngAfterViewInit() {
        this.init();
    }

    public onSave = async (): Promise<any> => {
        if (this.validationHandlerService.checkFormValid(this.form)) {
            const languages = this.getLanguageValueFormArray().map(control => control.value);
            const dictionary: { [key: string]: string } = {};
            languages.forEach((language: any) => {
                dictionary[language.languageCode] = language.languageValue;
            });

            let itemToSave: ResourceSaveModel = {
                key: this.item?.key,
                type: this.item?.type,
                languageKeyValue: dictionary,
            };
            return this.handleSpinner(
                firstValueFrom(this.coreService.updateResource(itemToSave))
                    .then(res => {
                        this.onClose(this.bsModalRef, 'save_success');
                        return Promise.resolve(res);
                    })
                    .catch((err: HttpErrorResponse) => {
                        this.validationHandlerService.handleServerError(err);
                    })
            );
        }
    };
}
